import { useEffect, useState } from "react";
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import { Link } from "@/helpers/common_helper";
import { pagelink } from "@/config/site";
import _ from 'lodash';
import { FaRegClock } from "react-icons/fa";

/**
 * 
 * @param {Object} props
 * @param {ArticleData&TagData} props.content
 */
export const SliderContent = ({content}) => {
    let tagList = JSON.parse(content.tag);
    const articleLink = pagelink.article.articleMidUrl;
    return (<>
        <div className="swiper-slide" style={{cursor:'pointer'}}>
            <div className="guide-sport-box">
                <Link href={ `${articleLink}${content.custom_url}` }>
                    <div className="image-holder">
                        <img src={ content.cover_image ? `${process.env.NEXT_PUBLIC_FS_URL}${content.cover_image}` : '/assets/images/article-image-demo.png' } alt="" className="img-fluid" />
                    </div>
                </Link>
                <div className="text-box">
                    <Link href={ `${articleLink}${content.custom_url}` }>
                        <div className="text-box-inner">
                            <ul>
                                <li>{content.type}</li>
                                <li><FaRegClock className="guide-clock-icon" />{content.datetimediff}</li>
                            </ul>
                            <h3>{content.subject}</h3>
                            <p dangerouslySetInnerHTML={{ __html: content.description }} />
                        </div>
                    </Link>
                    <div className="guide-sport-list">
                        <ul>
                            {_.map(tagList, tl => (
                                <li key={tl.tag_id}><a href="#">{tl.display_name}</a></li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default function Guide(props) {
    const { t, type, sliderData } = props;
    const swiper = useSwiper();

    return (
        <>
            <div className="guide-sport-inner">
                <div className="guide-swiper-btn">
                    <div className={"swiper-button-prev button-prev-" + type}><img src="/assets/images/slide-left-arrow.png" alt="" /></div>
                    <div className={"swiper-button-next button-next-" + type}><img src="/assets/images/slide-right-arrow.png" alt="" /></div>
                </div>
                <Swiper
                    initialSlide={3}
                    className={"swiper mySwiper"}
                    spaceBetween={20}
                    slidesPerView={3}
                    // onSlideChange={() => console.log('')}
                    // onSwiper={() => console.log('')}
                    modules={[Navigation]}
                    navigation={{
                        prevEl: ".button-prev-" + type,
                        nextEl: ".button-next-" + type
                    }}
                    loop={true}
                    breakpoints={{
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 15,
                            initialSlide: 2
                        },
                        375: {
                            slidesPerView: 1.1,
                            spaceBetween: 15,
                            initialSlide: 2
                        },
                        768: {
                            slidesPerView: 2.1,
                            spaceBetween: 22,
                            initialSlide: 3
                        },
                        // when window width is >= 640px
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            initialSlide: 3
                        }
                    }}
                >
                    <div className="swiper-wrapper">
                        {
                            sliderData?.length > 0 ?
                                _.map(sliderData, sd => (
                                    <SwiperSlide key={sd.article_id}><SliderContent content={sd}/></SwiperSlide>
                                ))
                                :
                                null
                        }
                    </div>
                </Swiper>
            </div>
        </>
    )
}